import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingPage.css';

export default function AccessCheck() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<'not_found' | 'unconfirmed' | 'pending_invite' | 'generic' | null>(null);
  const [logoError, setLogoError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email || !email.includes('@')) {
      setError('generic');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await fetch('https://api.flexara.ro/auth/check-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        navigate('/login', { state: { email } });
      } else if (res.status === 403) {
        const data = await res.json();
        if (data.detail === 'unconfirmed') setError('unconfirmed');
        else if (data.detail === 'pending_invite') setError('pending_invite');
        else setError('generic');
      } else if (res.status === 404) {
        setError('not_found');
      } else {
        setError('generic');
      }
    } catch {
      setError('generic');
    }
    setLoading(false);
  };

  return (
    <div className="lp" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '2rem' }}>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: '2rem' }}>
          {!logoError ? (
            <img
              src="/flexara-icon.png"
              alt="Flexara"
              width={32}
              height={32}
              style={{ borderRadius: 6 }}
              onError={() => setLogoError(true)}
            />
          ) : (
            <span style={{ display: 'flex', width: 32, height: 32, borderRadius: 8, background: '#1F4E79', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="8" fill="#1F4E79" />
                <text x="7" y="22" fontFamily="serif" fontSize="18" fontWeight="bold" fill="#F39C12">F</text>
                <rect x="18" y="8" width="3" height="3" rx="1" fill="#F39C12" opacity="0.9" />
                <rect x="18" y="13" width="3" height="5" rx="1" fill="#F39C12" opacity="0.7" />
                <rect x="18" y="20" width="3" height="3" rx="1" fill="#F39C12" opacity="0.5" />
              </svg>
            </span>
          )}
          <span className="logo-text">Flexara</span>
        </div>

        {/* Card */}
        <div style={{ background: 'rgba(255,255,255,0.04)', border: '0.5px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '2rem' }}>
          <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, color: '#fff', marginBottom: '0.5rem', fontWeight: 400 }}>
            Intră în contul tău
          </h2>
          <p style={{ fontSize: 14, color: 'rgba(232,240,248,0.5)', marginBottom: '1.5rem', fontWeight: 300 }}>
            Introduceți adresa de email cu care v-ați înregistrat.
          </p>

          <div className="email-row" style={{ flexDirection: 'column', gap: 12, maxWidth: '100%' }}>
            <input
              type="email"
              placeholder="email@exemplu.ro"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{ height: 46, width: '100%' }}
            />
            <button
              className="btn-primary"
              disabled={loading}
              onClick={handleSubmit}
              style={{ width: '100%' }}
            >
              {loading ? 'Se verifică...' : 'Continuă'}
            </button>
          </div>

          {error === 'unconfirmed' && (
            <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(232,240,248,0.6)', lineHeight: 1.5 }}>
              Ai primit un email de confirmare. Verifică inbox-ul și confirmă adresa înainte de a continua.
            </p>
          )}
          {error === 'pending_invite' && (
            <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(232,240,248,0.6)', lineHeight: 1.5 }}>
              Ești pe lista de așteptare. Te vom contacta cu invitația de acces în curând.
            </p>
          )}
          {error === 'not_found' && (
            <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(232,240,248,0.6)', lineHeight: 1.5 }}>
              Această adresă de email nu are un cont activ.{' '}
              <Link to="/" style={{ color: '#F39C12', textDecoration: 'none' }}>
                Înscrie-te pe lista de așteptare.
              </Link>
            </p>
          )}
          {error === 'generic' && (
            <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(220,100,100,0.85)' }}>
              A apărut o eroare. Încearcă din nou.
            </p>
          )}
        </div>

        {/* Back link */}
        <p style={{ textAlign: 'center', marginTop: '1.25rem' }}>
          <Link to="/" className="nav-login">
            ← Înapoi
          </Link>
        </p>
      </div>
    </div>
  );
}
